import { render, staticRenderFns } from "./DeleteAccountStepFour.vue?vue&type=template&id=3133bdd2&scoped=true"
import script from "./DeleteAccountStepFour.vue?vue&type=script&lang=js"
export * from "./DeleteAccountStepFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133bdd2",
  null
  
)

export default component.exports